'use strict';

function icPart(str) {
  return str.split('').map(function (c) {
    return '(?:' + [c.toUpperCase(), c.toLowerCase()].join('|') + ')';
  }).join('');
}

module.exports = icPart;